import { IFileService } from './IFileService';
import { ExportData } from './IDatabaseService';

/**
 * Electron file service adapter
 * Uses native Electron file dialogs for file operations
 * Note: In Electron, file I/O happens in the main process, so this adapter
 * just returns the data that was read by the main process.
 */
export class ElectronFileAdapter implements IFileService {
  async importJSON(): Promise<ExportData> {
    // Show native file open dialog
    const result = await window.electronAPI.showOpenDialog({
      filters: [
        { name: 'JSON Files', extensions: ['json'] },
        { name: 'Flash-E Export', extensions: ['flashe'] }
      ],
      properties: ['openFile']
    });

    if (result.canceled || !result.filePaths || result.filePaths.length === 0) {
      throw new Error('Import cancelled');
    }

    // Read and parse the file via Electron IPC
    const filePath = result.filePaths[0];

    // The current Electron API's importData expects a filePath and does the reading itself
    // So we need to read the file here and return the parsed data
    // This will be handled by a new IPC method we need to add
    const data = await window.electronAPI.readJSONFile(filePath);

    return data;
  }

  async exportJSON(data: ExportData, filename: string): Promise<void> {
    // Show native save dialog
    const result = await window.electronAPI.showSaveDialog({
      defaultPath: filename,
      filters: [
        { name: 'JSON Files', extensions: ['json'] },
        { name: 'Flash-E Export', extensions: ['flashe'] }
      ]
    });

    if (result.canceled || !result.filePath) {
      throw new Error('Export cancelled');
    }

    // Write file via Electron IPC
    await window.electronAPI.writeJSONFile(result.filePath, data);
  }
}
